// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  matchId: __t.string().name("match_id"),
  mapName: __t.string().name("map_name"),
  phase: __t.string(),
  hostPlayerId: __t.string().name("host_player_id"),
  hostPlayerName: __t.string().name("host_player_name"),
  playerNames: __t.string().name("player_names"),
  playerCount: __t.u32().name("player_count"),
  armyBudget: __t.u32().name("army_budget"),
  maxArmySize: __t.u32().name("max_army_size"),
  ruleset: __t.string(),
  season: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
});
